import { ReactNode } from 'react'
import { RxPencil2 } from 'react-icons/rx'
import { Button } from '~/@/components/ui/button'
import { AnimatedDossbotIcon } from '~/components/dossbot/AnimatedDossbotIcon'
import { DossbotChat } from '~/components/dossbot/DossbotChat'
import { DossbotChatSwitcher } from '~/components/dossbot/DossbotChatSwitcher'
import { DossbotNewChat } from '~/components/dossbot/DossbotNewChat'

type DossbotChatPanelProps = {
  chatId: string | null
  onSelectChat: (chatId: string) => void
  onNewChat: () => void
  actions?: ReactNode
  compact?: boolean
}

/** Shared Dossbot chat panel used by both the popup widget and mobile Dossbot page. */
export const DossbotChatPanel = ({
  chatId,
  onSelectChat,
  onNewChat,
  actions,
  compact,
}: DossbotChatPanelProps) => (
  <div className="flex h-full flex-col overflow-hidden">
    <div className="flex items-center justify-between border-b border-gray-4 px-4 py-3">
      <div className="flex min-w-0 flex-1 items-center">
        <div className="flex size-8 items-center justify-center">
          <AnimatedDossbotIcon animate={false} height={20} width={20} />
        </div>
        <DossbotChatSwitcher chatId={chatId} hasAccess onChatSwitch={onSelectChat} />
      </div>
      <div className="flex items-center gap-1">
        <Button
          aria-label="Create new chat"
          className="size-8"
          onClick={onNewChat}
          size="icon"
          variant="ghost"
        >
          <RxPencil2 size={16} />
        </Button>
        {actions}
      </div>
    </div>
    <div className="flex-1 overflow-hidden">
      {chatId ? (
        <DossbotChat chatId={chatId} compactMessages={compact} />
      ) : (
        <DossbotNewChat onCreateChat={onSelectChat} />
      )}
    </div>
  </div>
)
